//@flow

export const LOCALE_EN = "en-US"
export const LOCALE_ES = "es-ES"
export const LOCALE_COOKIE = "LOCALE"



// WEBPACK FOOTER //
// ./src/Intl/constants.js